import ReactDOM from "react-dom";
import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";

import UiMQRCodeOverlay from "../../../uiModules/uiMQRCodeOverlay/UiMQRCodeOverlay";
import UiMARCodeAvailabilityOverlay from "../../../uiModules/uiMARCodeAvailabilityOverlay/UiMARCodeAvailabilityOverlay";
import { isDesktopUserAgent } from "../../../helpers/utils";

import "./_UimAROverlay.scss";

export type iAROverlay = {
  tTitle: string;
  tBody: string;
  tLabel: string;
};

type UimAROverlayProps = {
  className?: string;
  urlLink: string;
  arOverlay: iAROverlay;
  arReady: iAROverlay;
  arUnavailable: iAROverlay;
  openQRCodeOverlay: boolean;
  openQRCodeLinkOverlay: boolean;
  openARUnavailableOverlay: boolean;
  setOpenQRCodeOverlay: (value: boolean) => void;
  setOpenQRCodeLinkOverlay: (value: boolean) => void;
  setOpenARUnavailableOverlay: (value: boolean) => void;
};

const arReadyDefault = {
  tTitle: "AR Ready",
  tBody:
    "We've found an Augmented Reality instance for you. Click the link below to view in AR.",
  tLabel: "Launch AR",
};
const arUnavailableDefault = {
  tTitle: "AR not available",
  tBody: "There are currently no AR streams available. Please try again later.",
  tLabel: "Close",
};

const UimAROverlay = ({
  className = "",
  urlLink,
  arOverlay,
  arReady = arReadyDefault,
  arUnavailable = arUnavailableDefault,
  openQRCodeOverlay,
  openQRCodeLinkOverlay,
  openARUnavailableOverlay,
  setOpenQRCodeOverlay,
  setOpenQRCodeLinkOverlay,
  setOpenARUnavailableOverlay,
}: UimAROverlayProps) => {
  const { projectClass } = useUiContext();

  if (!openQRCodeOverlay && !openARUnavailableOverlay && !openQRCodeLinkOverlay) {
    return null;
  }

  const getClassName = () => classNames(`${projectClass}_UimAROverlay`, className);

  const overlayContent = (
    <div className={getClassName()}>
      {openQRCodeOverlay && isDesktopUserAgent() && arOverlay && (
        <UiMQRCodeOverlay
          open={openQRCodeOverlay}
          setOpen={setOpenQRCodeOverlay}
          tTitle={arOverlay.tTitle}
          tBody={arOverlay.tBody}
          tLabel={arOverlay.tLabel || "Close"}
        />
      )}
      {openARUnavailableOverlay && (
        <UiMARCodeAvailabilityOverlay
          open={openARUnavailableOverlay}
          setOpen={setOpenARUnavailableOverlay}
          tTitle={arUnavailable.tTitle}
          tBody={arUnavailable.tBody}
          tLabel={arUnavailable.tLabel}
        />
      )}
      {openQRCodeLinkOverlay && (
        <UiMARCodeAvailabilityOverlay
          open={openQRCodeLinkOverlay}
          setOpen={setOpenQRCodeLinkOverlay}
          tTitle={arReady.tTitle}
          tBody={arReady.tBody}
          tLabel={arReady.tLabel}
          arIntentUrl={urlLink}
        />
      )}
    </div>
  );

  return ReactDOM.createPortal(
    overlayContent,
    document.getElementById("EBRO_overlay-root") ?? document.createElement("div"),
  );
};

export default UimAROverlay;
